/* FBT Apply Offers — expand/collapse the coupon dropdown and copy codes.
   Self-initialising for every [data-fbt-offers] on the page (mobile + desktop). */
(function () {
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  function init(root) {
    if (root.dataset.fbtOffersReady === 'true') return;
    root.dataset.fbtOffersReady = 'true';

    var toggle = root.querySelector('[data-fbt-offers-toggle]');
    var panel = root.querySelector('[data-fbt-offers-panel]');

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      });
    }

    root.querySelectorAll('[data-fbt-offers-copy]').forEach(function (btn) {
      var code = btn.getAttribute('data-fbt-offers-copy');
      var wrap = btn.closest('.fbt-offers__code-wrap');
      var hintText = wrap ? wrap.querySelector('[data-fbt-offers-hint-text]') : null;
      var idleLabel = hintText ? hintText.textContent : 'copied';

      btn.addEventListener('click', function () {
        copyText(code).then(function () {
          if (!wrap) return;
          wrap.classList.add('is-copied');
          if (hintText) hintText.textContent = 'copied';
          clearTimeout(wrap._fbtTimer);
          wrap._fbtTimer = setTimeout(function () {
            wrap.classList.remove('is-copied');
            if (hintText) hintText.textContent = idleLabel;
          }, 2000);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fbt-offers]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', initAll);
})();
